import React from 'react';

const KPISkeletonCard = () => (
    <div className="bg-white p-5 rounded-xl shadow-sm flex items-center space-x-4">
        <div className="bg-slate-200 rounded-full h-14 w-14"></div>
        <div className="flex-1 space-y-3">
            <div className="h-4 bg-slate-200 rounded w-3/4"></div>
            <div className="h-6 bg-slate-200 rounded w-1/2"></div>
        </div>
    </div>
);

const ChartSkeletonCard = ({ className = '' }) => (
    <div className={`bg-white p-4 sm:p-6 rounded-xl shadow-sm ${className}`}>
        <div className="h-6 bg-slate-200 rounded w-1/3 mb-4"></div>
        <div className="h-80 w-full bg-slate-200 rounded-lg"></div>
    </div>
);

export const ChartContentSkeleton = () => (
    <div className="w-full h-full p-4 flex flex-col justify-end animate-pulse">
        <div className="space-y-2">
            <div className="h-4 bg-slate-200 rounded w-full"></div>
            <div className="h-4 bg-slate-200 rounded w-5/6"></div>
            <div className="h-4 bg-slate-200 rounded w-full"></div>
            <div className="h-4 bg-slate-200 rounded w-4/6"></div>
            <div className="h-4 bg-slate-200 rounded w-2/3"></div>
        </div>
    </div>
);

const DashboardSkeleton = () => {
    return (
        <div className="animate-pulse space-y-4 md:space-y-6 lg:space-y-8">
            {/* KPI Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                <KPISkeletonCard />
                <KPISkeletonCard />
                <KPISkeletonCard />
                <KPISkeletonCard />
                <KPISkeletonCard />
                <KPISkeletonCard />
                <KPISkeletonCard />
                <KPISkeletonCard />
            </div>

            {/* Charts Section */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
                <ChartSkeletonCard />
                <ChartSkeletonCard />
                <ChartSkeletonCard />
                <ChartSkeletonCard />
            </div>
        </div>
    );
};

export default DashboardSkeleton;